import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import NonFloatingLegends from "./nonFloatingLegends.jsx";
import NumberAbbreviator from "../../../../core/utils/numberAbbreviator.js";
import WidgetService from "../../../../core/services/widgetService.js";
import UniqueIdGenerator from "../../../../core/utils/uniqueIdGenerator";
import styles from "./widget.scss";

var Controller = require('./controller.js');

export default class PieWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      floatingLegend: !this.props.widget.metaData.showLegends,
      data: []
    }
  }

  componentWillMount() {
    var component;
    for (var componentId in this.props.components) {
      component = this.props.components[componentId];
    }
    this.componentId = UniqueIdGenerator.id();
    this.controller = new Controller(this.componentId, this.props.widgetId, this.props.legends, this.props.togglePreloader);
    this.isAnimating = false;
    this.isDummyPieChartHidden = false;
    this.needToUpdateLatest = false;
    this.LABEL_WIDTH = 120;
    this.MOBILE_WIDTH = 600;
    this.initialized = false;
  }

  componentDidMount() {
    this.initializePieChartGraphics(this.componentId);
    this.renderDummyPieChart(this.componentId);

    // submit component add intention to start updating component on data receive
    this.controller.addUpdateListener(this.update);
    WidgetService.addComponentToWidget(this.props.widgetId, this.controller);

    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE, this.onWidgetResize);
    this.subscribe(InternalEvent.Dashboard.WIDGET_RESIZE_STOP, (payload) => {
      this.onWidgetResize(payload);
      this.isResizing = false;
    });
  }

  componentWillUnmount() {
    this.controller.destroy();
    this.unsubscribeAll();
  }

  initializePieChartGraphics(componentId, containerWidth, containerHeight) {
    var that = this;
    var $container = $('#' + componentId + ' .pie-chart-container').empty();

    that.svg = d3.select('#' + componentId + ' .pie-chart-container')
      .append('svg')
      .append('g');

    that.svg.append("g")
      .attr("class", "slices");
    that.svg.append("g")
      .attr("class", "labels");
    that.svg.append("g")
      .attr("class", "lines");

    var $widgetWrapper = $container.parent().parent();
    var width = containerWidth || $widgetWrapper.width();
    var titleHeight = 0;
    if ($widgetWrapper.find('h1[name="widgetTitle"]').length > 0) {
      titleHeight = $widgetWrapper.find('h1[name="widgetTitle"]').outerHeight();
    }
    var height = containerHeight || $widgetWrapper.height() - titleHeight;


    if ($container.parents("#add-widget").length === 0) {
      if (isMobile()) {
        that.setState({floatingLegend: false});
        height = height - this.props.legends.length * 30;
      } else if (!this.state.floatingLegend) {
        width = width - 130;
        this.LABEL_WIDTH = 0;
      }
    }

    $container.width(width).height(height);
    $container.find('svg').width(width).height(height);
    that.radius = Math.min((width - this.LABEL_WIDTH), height) / 2;


    that.pie = d3.pie()
      .sort(null)
      .value(function (d) {
        return d.y;
      });

    that.arc = d3.arc()
      .outerRadius(that.radius * 0.9)
      .innerRadius(that.radius * 0.6);

    that.outerArc = d3.arc()
      .innerRadius(that.radius * 0.9)
      .outerRadius(that.radius * 0.9);

    that.svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    that.key = function (d) {
      return d.data.identifier;
    };

    var domain = [], range = [];
    for (var i in this.props.legends) {
      var legend = this.props.legends[i];
      var datasetId = legend.datasetId;
      var fieldPath = legend.fieldPath;
      var identifier = legend.id;
      domain.push(identifier);
      range.push(legend.parameters.legendColor);
    }
    that.color = d3.scaleOrdinal()
      .domain(domain)
      .range(range);

    if (that.lastDataUpdated != null) {
      that.renderPieChart(that.lastDataUpdated, this.componentId);
    }
  }


  renderDummyPieChart(componentId) {
    var that = this;
    var $container = $('#' + componentId + ' .dummy-pie-chart').empty();

    var svg = d3.select('#' + componentId + ' .dummy-pie-chart')
      .append('svg')
      .append('g');

    svg.append("g")
      .attr("class", "slices");

    var $widgetWrapper = $container.parent().parent();
    var width = $widgetWrapper.width();
    var titleHeight = 0;
    if ($widgetWrapper.find('h1[name="widgetTitle"]').length > 0) {
      titleHeight = $widgetWrapper.find('h1[name="widgetTitle"]').outerHeight();
    }
    var height = $widgetWrapper.height() - titleHeight;

    if ($container.parents("#add-widget").length === 0) {
      if (isMobile()) {
        that.setState({floatingLegend: false});
        height = height - this.props.legends.length * 30;
      } else if (!this.state.floatingLegend) {
        width = width - 200;
      }
    }

    $container.width(width).height(height);
    $container.find('svg').width(width).height(height);
    var radius = Math.min((width - this.LABEL_WIDTH), height) / 2;

    var pie = d3.pie()
      .sort(null)
      .value(function (d) {
        return d.y;
      });

    var arc = d3.arc()
      .outerRadius(radius * 0.9)
      .innerRadius(radius * 0.892);
    var arc2 = d3.arc()
      .outerRadius(radius * 0.5)
      .innerRadius(radius * 0.492);

    svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    var key = function (d) {
      return d.data.identifier;
    };

    var mockData = [{
      identifier: 'someId',
      y: 1
    }];

    var slice = svg.select(".slices").selectAll("path.slice")
      .data(pie(mockData), key);

    slice.enter()
      .append("path")
      .attr("fill", function (d) {
        return '#E6E6E6';
      })
      .attr("class", "slice")
      .merge(slice)
      .transition().duration(1000)
      .attrTween("d", function (d) {
        this._current = this._current || d;
        var interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function (t) {
          return arc(interpolate(t));
        };
      })
    slice.exit()
      .remove();

    slice.enter()
      .insert("path")
      .style("fill", function (d) {
        return '#E6E6E6';
      })
      .attr("class", "slice")
      .merge(slice)
      .transition().duration(1000)
      .attrTween("d", function (d) {
        this._current = this._current || d;
        var interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function (t) {
          return arc2(interpolate(t));
        };
      });
    slice.exit()
      .remove();

    // mid total label
    var totalLabel = 0;
    var $pieChartContainer = $('#' + componentId + ' .dummy-pie-chart');
    var $midLabel = $('<div class="mid-label">' + totalLabel + '</div>');
    $midLabel.css({
      'font-size': Math.floor(that.radius * 0.22)
    });
    $midLabel.width($pieChartContainer.width());
    $pieChartContainer.append($midLabel);
  }

  update(newData, componentId) {
    var that = this;
    //!that.isAnimating && !that.isResizing
    if (!that.isAnimating && !that.isResizing) {
      if (isAllZero(newData)) {
        that.isAnimating = true;
        $('#' + componentId + ' .dummy-pie-chart').css('display', '');
        that.isDummyPieChartHidden = false;
        $('#' + componentId + ' .pie-chart-container').css('display', 'none');

        setTimeout(function () {
          that.isAnimating = false;
        }, 1200);
        return;
      }
      else {
        if (!that.isDummyPieChartHidden) {
          $('#' + componentId + ' .dummy-pie-chart').css('display', 'none');
          $('#' + componentId + ' .pie-chart-container').css('display', '');
          that.isDummyPieChartHidden = true;
        }
      }

      that.isAnimating = true;
      that.lastDataUpdated = newData;
      that.setState({data: newData});
      that.renderPieChart(newData, componentId);
    }
    else {
      that.needToUpdateLatest = true;
    }

    function isAllZero(newData) {
      for (var i in newData) {
        if (newData[i].y !== 0) {
          return false;
        }
      }
      return true;
    }
  }

  renderPieChart(newData, componentId) {
    newData = newData.filter(d => !isNaN(d.y) && d.y != null);
    var _this = this;
    var containerWidth = $("#" + this.componentId).width();
    var labelWidth = (containerWidth - this.radius * 2) / 2 - 10;
    /* ------- PIE SLICES -------*/
    var slice = _this.svg.select(".slices").selectAll("path.slice")
      .data(_this.pie(newData), _this.key);

    var numSlices = newData.length;
    var animationTracker = {
      completedCounter: this.state.floatingLegend ? numSlices * 3 : numSlices
    };

    slice.enter()
      .insert("path")
      .style("fill", function (d) {
        return _this.getLegend(d.data.identifier).parameters.legendColor;
      })
      .attr("class", "slice")
      .merge(slice)
      .transition().duration(1000)
      .attrTween("d", function (d) {
        this._current = this._current || d;
        var interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        return function (t) {
          return _this.arc(interpolate(t));
        };
      })
      .style("fill", function (d) {
        return _this.getLegend(d.data.identifier).parameters.legendColor;
      })
      .call(endAll, allAnimationsCompletedCallback);

    slice.exit()
      .remove();

    if (this.state.floatingLegend) {
      /* ------- TEXT LABELS -------*/
      var t = _this.svg.select(".labels").selectAll("#" + componentId + ' .pie-label')
        .data(_this.pie(newData), _this.key);
      t.enter()
        .append("foreignObject")
        .attr("width", labelWidth)
        .attr("height", 50)
        .attr("dy", ".35em")
        .attr('class', 'pie-label')
        .append("xhtml:div")
        .html(function (d) {
          $(this).attr('data-identifier', d.data.identifier);
          return '<span style="color:#808080;">'
            + d.data.legendLabel
            + '</span><br /><div style="color:#808080;">'
            + d.data.y
            + '</div><div style="color:#808080;"></div>';
        });

      var text = _this.svg.select(".labels").selectAll("#" + componentId + ' .pie-label')
        .data(_this.pie(newData), _this.key);

      function midAngle(d) {
        return d.startAngle + (d.endAngle - d.startAngle) / 2;
      }

      text.enter()
        .append("foreignObject")
        .attr("width", labelWidth)
        .attr("height", 50)
        .attr("dy", ".35em")
        .attr('class', 'pie-label')
        .append("xhtml:div")
        .html(function (d) {
          $(this).attr('data-identifier', d.data.identifier);
          return '<span style="color:#808080;">'
            + d.data.legendLabel
            + '</span><br /><div style="color:#808080;">'
            + d.data.y
            + '</div><div style="color:#808080;"></div>';
        })
        .merge(text)
        .transition().duration(1000)
        .attrTween("transform", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            var d2 = interpolate(t);
            var pos = _this.outerArc.centroid(d2);
            pos[0] = _this.radius * (midAngle(d2) < Math.PI ? 1 : -1);
            pos[1] -= 5;
            if (midAngle(d2) >= Math.PI) {
              pos[0] -= labelWidth;
            }
            return "translate(" + pos + ")";
          };
        })
        .styleTween("text-align", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            var d2 = interpolate(t);
            return midAngle(d2) < Math.PI ? "start" : "end";
          };
        })
        .call(endAll, allAnimationsCompletedCallback);


      text.exit()
        .remove();

      /* ------- SLICE TO TEXT POLYLINES -------*/
      var polyline = _this.svg.select(".lines").selectAll("polyline")
        .data(_this.pie(newData), _this.key);

      polyline.enter()
        .append('polyline')
        .html(function (d) {
          $(this).attr('data-identifier', d.data.identifier);
        })
        .merge(polyline)
        .transition().duration(1000)
        .attrTween("points", function (d) {
          this._current = this._current || d;
          var interpolate = d3.interpolate(this._current, d);
          this._current = interpolate(0);
          return function (t) {
            var d2 = interpolate(t);
            var pos = _this.outerArc.centroid(d2);
            pos[0] = _this.radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
            return [_this.arc.centroid(d2), _this.outerArc.centroid(d2), pos];
          };
        })
        .call(endAll, allAnimationsCompletedCallback);

      polyline.exit()
        .remove();
    }

    // updating individual slice values
    var total = 0, totalPercent = 0;
    for (var i = 0; i < newData.length; i++) {
      const val = newData[i].y;
      total += isNaN(val) ? 0 : val;
    }

    for (var i = 0; i < newData.length; i++) {
      var percentValue = newData[i].y > 0 ? newData[i].y / total * 100 : 0;
      percentValue = Math.round(percentValue * 10) / 10;
      if (i === newData.length - 1) {
        percentValue = Math.round((100 - totalPercent) * 10) / 10;
      }
      totalPercent += percentValue;

      var $label = $('#' + componentId + ' .labels div[data-identifier="' + newData[i].identifier + '"]');
      var $line = $('#' + componentId + ' .lines polyline[data-identifier="' + newData[i].identifier + '"]');

      if (newData[i].y === 0) {
        $label.addClass('hidden');
        $line.attr('class', 'hidden');
      }
      else {
        var legend = this.getLegend(newData[i].identifier);
        var value = NumberAbbreviator.format(newData[i].y);

        $label.find('span')
          .css("color", "#808080")
          .text(legend.parameters.legendLabel);
        $($label.find('div')[0]).text(`${value} (${percentValue}%)`);
        // $($label.find('div')[1]).text(percentValue + "%");
        $label.removeClass('hidden');
        $line.attr('class', '');
      }
    }

    // mid total label
    var $midLabel = $('#' + componentId + ' .pie-chart-container .mid-label');
    var totalLabel = NumberAbbreviator.format(total);
    if ($midLabel.length === 0) {
      var $pieChartContainer = $('#' + componentId + ' .pie-chart-container');
      var $midLabel = $('<div class="mid-label">' + totalLabel + '</div>');
      $midLabel.css({
        'font-size': Math.floor(_this.radius * 0.22)
      });
      $midLabel.width($pieChartContainer.width());
      $pieChartContainer.append($midLabel);
    }
    else {
      $midLabel.fadeOut(function () {
        $midLabel.text(totalLabel);
        $midLabel.fadeIn();
      })
    }

    function allAnimationsCompletedCallback() {
      _this.isAnimating = false;

      if (_this.needToUpdateLatest) {
        _this.needToUpdateLatest = false;
        _this.controller.update();
      }
    };

    function endAll(transition, callback) {
      if (!transition.empty()) {
        animationTracker.completedCounter -= transition._groups[0].length;
        if (animationTracker.completedCounter === 0) {
          callback();
        }
      }
    }

  }

  getLegend(legendId) {
    var legends = WidgetService.getWidget(this.props.widgetId).legends;
    for (var i = 0; i < legends.length; i++) {
      if (legends[i].id === legendId) {
        return legends[i];
      }
    }
  }

  onWidgetResize(data) {
    var _this = this;
    var widget = data.widget;
    var componentId = $(widget.children("div")[0]).find('.pie-chart-outer-wrapper').attr('id');
    if (this.componentId == componentId) {
      setTimeout(function () {
        _this.isResizing = data.isFromToggleWidgetSize || true;
        _this.initializePieChartGraphics(componentId, data.width, data.height);
        _this.renderDummyPieChart(componentId);
        if (data.maximized != null) {
          _this.isResizing = false;
        }
      }, data.maximized != null ? 300 : 0);
    }
  }

  onWidgetResizeStop() {
    this.isResizing = false;
  }

  render() {
    var legends;
    const style = {};
    if (!this.state.floatingLegend) {
      legends =
        <NonFloatingLegends legends={this.props.legends} data={this.state.data}/>;
    }

    if (this.props.widget.metaData.showLegends) {
      style.display = "flex";
    }

    if(isMobile()) {
      style.display = "flex";
      style.flexDirection = "column";
    }

    return (
      <div id={this.componentId} className="pie-chart-outer-wrapper" style={style} ref="container">
        <div className="pie-chart-container" ref="pieContainer" style={{display: 'none'}}></div>
        <div className="dummy-pie-chart"></div>
        {legends}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/pie-chart/pieWidget.jsx